import USER_TYPES from '@/constants/authorization/user-types'

const SHORTCUTS_SECTIONS = [
  /* eslint-disable global-require */
  {
    key: 'services',
    title: 'navigation.services',
    userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR, USER_TYPES.OWNER],
    sections: [
      {
        key: 'dine_in',
        title: 'selling-types.types.dinein',
        route: 'admin:branches-management',
        featureKey: 'dine_in',
        index: 3,
      },
      {
        key: 'delivery',
        title: 'selling-types.types.delivery',
        route: 'admin:branches-management',
        featureKey: 'delivery',
        index: 4,
      },
      {
        key: 'pickup',
        title: 'selling-types.types.car_pickup',
        route: 'admin:branches-management',
        featureKey: 'pickup',
        index: 5,
      },
      {
        key: 'queue',
        title: 'features.queue',
        route: 'admin:branches-management',
        featureKey: 'queue',
        index: 6,
      },
      {
        key: 'reservations',
        title: 'features.reservations',
        route: 'admin:branches-management',
        featureKey: 'assign_table',
        index: 7,
      },
    ],
  },
  {
    key: 'tools',
    title: 'navigation.tools',
    userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.OWNER],
    sections: [
      {
        key: 'payment_methods',
        title: 'payment-methods.payment-methods',
        route: 'admin:branches-management',
        featureKey: null,
        index: 8,
      },
      {
        key: 'qr_codes',
        title: 'qr-code.qr-codes',
        route: 'admin:qr',
        featureKey: null,
        index: 0,
      },
      {
        key: 'devices',
        title: 'navigation.devices',
        route: 'admin:devices',
        featureKey: 'devices',
        index: 0,
      },
      {
        key: 'widget',
        title: 'navigation.widget',
        route: 'admin:widget',
        featureKey: null,
        index: 0,
      },
    ],
  },
  {
    key: 'appearance',
    title: 'navigation.appearance',
    userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.OWNER],
    sections: [
      {
        key: 'website_themes',
        title: 'design.qr.qr-menu-themes',
        route: 'admin:design:qr',
        featureKey: 'themes',
        index: 0,
      },
      {
        key: 'ipad_themes',
        title: 'design.tablet.ipad-themes',
        route: 'admin:design:tablet',
        featureKey: 'themes',
        index: 0,
      },
      /* {
        key: 'mobile_themes',
        title: 'design.mobile.themes',
        route: 'admin:design:mobile',
        featureKey: 'themes',
        index: 0,
      }, */
      {
        key: 'receipt',
        title: 'design.receipt-settings',
        route: 'admin:design:receipt-setting',
        featureKey: null,
        index: 0,
      },
    ],
  },
  {
    key: 'users',
    title: 'navigation.users',
    userTypes: [USER_TYPES.OWNER],
    sections: [
      {
        key: 'users',
        title: 'navigation.users',
        route: 'admin:users-wizard',
        index: 0,
      },
      {
        key: 'activity_logs',
        title: 'activity-logs.activity-logs',
        route: 'admin:users-wizard',
        index: 1,
      },
    ],
  },
  {
    key: 'subscription',
    title: 'navigation.subscription',
    userTypes: [USER_TYPES.OWNER],
    sections: [
      {
        key: 'manage_subscription',
        title: 'subscription.manage-subscription',
        route: 'billing:manage-subscription',
        index: 0,
      },
      {
        key: 'plans',
        title: 'subscription.plans',
        route: 'billing:plans',
        index: 0,
      },
      {
        key: 'billing',
        title: 'subscription.billing',
        route: 'billing:billing-information',
        index: 0,
      },
    ],
  },
  {
    key: 'addons',
    title: 'navigation.addons',
    userTypes: [USER_TYPES.OWNER],
    sections: [
      {
        key: 'mobile-app',
        title: 'mobile.mobile-section',
        route: 'admin:addons:view',
        index: 0,
      },
      {
        key: 'google',
        title: 'google-menu.title',
        route: 'admin:addons:view',
        index: 0,
      },
      {
        key: 'whatsapp',
        title: 'profile.wp_label',
        route: 'admin:addons:view',
        index: 0,
      },
      {
        key: 'branded_domain',
        title: 'navigation.domains',
        route: 'admin:addons:view',
        index: 0,
      },
      {
        key: 'pixels',
        title: 'navigation.analytics-pixels',
        route: 'admin:addons:view',
        index: 0,
      },
      {
        key: 'ok_pos',
        title: 'navigation.cashier-app',
        route: 'admin:addons:view',
        index: 0,
      },
      {
        key: 'go_to_store',
        title: 'navigation.go-to-store',
        route: 'admin:store',
        index: 0,
      },
    ],
  },
]
export default SHORTCUTS_SECTIONS

export const SHORTCUTS_ICONS = {
  dine_in: require('@/assets/images/icons/shortcuts/dinein.svg'),
  pickup: require('@/assets/images/icons/shortcuts/pickup.svg'),
  delivery: require('@/assets/images/icons/shortcuts/delivery.svg'),
  queue: require('@/assets/images/icons/shortcuts/queue.svg'),
  queue_upgrade: require('@/assets/images/icons/shortcuts/queue-upgrade.svg'),
  reservations: require('@/assets/images/icons/shortcuts/reservation.svg'),
  reservations_upgrade: require('@/assets/images/icons/shortcuts/reservation-upgrade.svg'),
  payment_methods: require('@/assets/images/icons/shortcuts/payment.svg'),
  qr_codes: require('@/assets/images/icons/shortcuts/qrCode.svg'),
  devices: require('@/assets/images/icons/shortcuts/ipadTheme.svg'),
  widget: require('@/assets/images/icons/shortcuts/widget.svg'),
  website_themes: require('@/assets/images/icons/shortcuts/websitetheme.svg'),
  website_themes_upgrade: require('@/assets/images/icons/shortcuts/websitetheme-upgrade.svg'),
  ipad_themes: require('@/assets/images/icons/shortcuts/ipadTheme.svg'),
  ipad_themes_upgrade: require('@/assets/images/icons/shortcuts/ipadTheme-upgrade.svg'),
  mobile_themes: require('@/assets/images/icons/shortcuts/mobileTheme.svg'),
  mobile_themes_upgrade: require('@/assets/images/icons/shortcuts/mobileTheme-upgrade.svg'),
  receipt: require('@/assets/images/icons/shortcuts/receipt.svg'),
  users: require('@/assets/images/icons/shortcuts/users.svg'),
  activity_logs: require('@/assets/images/icons/shortcuts/activity.svg'),
  manage_subscription: require('@/assets/images/icons/shortcuts/subscription.svg'),
  plans: require('@/assets/images/icons/shortcuts/plans.svg'),
  billing: require('@/assets/images/icons/shortcuts/billing.svg'),
  mobile_app: require('@/assets/images/icons/shortcuts/mobileTheme.svg'),
  google: require('@/assets/images/icons/shortcuts/google.svg'),
  whatsapp: require('@/assets/images/icons/shortcuts/whatsapp.svg'),
  branded_domain: require('@/assets/images/icons/shortcuts/domain.svg'),
  pixels: require('@/assets/images/icons/shortcuts/analytics.svg'),
  ok_pos: require('@/assets/images/icons/shortcuts/cashier.svg'),
  go_to_store: require('@/assets/images/icons/shortcuts/store.svg'),

}
export const UPGRADED_SHORTCUTS = ['dine_in', 'delivery', 'pickup', 'reservations', 'delivery', 'queue', 'mobile-themes']
